import React, { Component } from 'react';
import { Picker, List, Toast, InputItem } from 'antd-mobile';
import * as services from '../projects/services';
import './style.less';
import { Button } from 'antd';
const CustomChildren = props => ( 
    <div
        onClick={props.onClick}
        className="checkcity"   >
        <div className="test" >
            <div className="name" >{props.children}</div>
            <div className="city" >{props.extra}</div>
        </div>
    </div>
);
export class AddAddress extends Component {

    constructor(props) {
        super(props);
      
        if (props.data.length !== 0) {
            this.state = {
                fname:'管理收货地址',
                addressid: props.data.addressid,
                pickerValue:[],
                addlist: [],
                antdDistrict: [],
                defaultAdd: props.data.provincename + props.data.cityname + props.data.countyname,
                parameter: {
                    addressId: props.data.addressid,
                    Consingee: props.data.consingee,
                    Provinceid: props.data.provinceid,
                    Provincename: '',
                    Cityid: props.data.cityid,
                    Cityname: '',
                    Countyid: props.data.countyid,
                    Countyname: '',
                    Adress: props.data.adress,
                    Zipcode: props.data.zipcode,
                    Linktel: props.data.linktel,
                    Email: props.data.email,
                }
            };
        } else {
            this.state = {
                fname:'添加收货地址',
                addressid: 0,
                pickerValue: [],
                addlist: [],
                antdDistrict: [],
                defaultAdd: '请选择(必选)',
                parameter: {
                    Consingee: '',
                    Provinceid: '',
                    Provincename: '',
                    Cityid: '',
                    Cityname: '',
                    Countyid: '',
                    Countyname: '',
                    Adress: '',
                    Zipcode: '',
                    Linktel: '',
                    Email: '',

                }
            };
        }
        this.handleChange1 = this.handleChange1.bind(this);
        this.handleChange2 = this.handleChange2.bind(this);
        this.handleChange3 = this.handleChange3.bind(this);
    }
    onClose = () => { // 学习挣钱，调用父组件方法       
        this.props.onClose();
    }
    componentDidMount() {
        let addlist = [];
        services.GetAllList('').then(value => {
            if (value.status === 0) {
                addlist = value.result;
                this.setState({ addlist: value.result });
                this.cm(addlist);
            } else {
                Toast.offline(value.status);
            }
        })
    }
    handleChange1(event) {
        let parameter = this.state.parameter;
        parameter.Consingee = event;
        this.setState({
            parameter: parameter
        });
    }
    handleChange2(event) {
        let parameter = this.state.parameter;
        parameter.Linktel = event;
        this.setState({
            parameter: parameter
        });

    }
    handleChange3(event) {
        let parameter = this.state.parameter;
        parameter.Adress = event;
        this.setState({
            parameter: parameter
        });

    }
    cm = (locationList) => {
        let antdDistrict = [];
        let districtData = locationList;
        Object.keys(districtData).forEach((index) => {
            let itemLevel1 = {};
            let itemLevel2 = {};
            itemLevel1.value = districtData[index].provinceCode;
            itemLevel1.label = districtData[index].provinceName;
            itemLevel1.children = [];

            let data = districtData[index].city;
            Object.keys(data).forEach((index) => {
                itemLevel2.value = data[index].cityCode;
                itemLevel2.label = data[index].cityName;
                itemLevel2.children = [];
                let data2 = data[index].county;
                let itemLevel3 = {};
                itemLevel3.children = [];
                Object.keys(data2).forEach((index) => {
                    itemLevel3.value = data2[index].countyCode;
                    itemLevel3.label = data2[index].countyName;
                    itemLevel2.children.push(itemLevel3);
                    itemLevel3 = {};
                });
                itemLevel1.children.push(itemLevel2);
                itemLevel2 = {};
            });
            antdDistrict.push(itemLevel1)
        });
        if (this.props.data != null) {
            this.setState({ antdDistrict: antdDistrict});
            this.setState(
                { antdDistrict: antdDistrict },
                () => {
                    this.setState({pickerValue: [this.props.data.provinceid, this.props.data.cityid, this.props.data.countyid] });                  
                   
                }
            );
        } else {
            this.setState({ antdDistrict: antdDistrict });
        }
    }
    onChange = (value) => {
        let parameter = this.state.parameter;
        parameter.Provinceid = value[0];
        parameter.Cityid = value[1];
        parameter.Countyid = value[2];
        this.setState({ pickerValue: value, parameter: parameter })      
    }
    address = () => {
        if (this.verification()) {
            if (this.state.addressid === 0) {
                services.AddAddress(this.state.parameter, '正在添加，请稍后').then((data) => {
                    if (data.status === 0) {
                        Toast.success(data.message);
                        this.onClose();
                    } else {
                        Toast.offline(data.message);
                    }
                })
            } else {
                services.EditAddress(this.state.parameter, '正在修改，请稍后').then((data) => {
                    if (data.status === 0) {
                        Toast.success(data.message);
                        this.onClose();
                    } else {
                        Toast.offline(data.message);
                    }
                })
            }
        }
    }
    verification = () => {
        var regex = /^1\d{10}$/;
        if (this.state.parameter.Consingee === '') {
            Toast.info('收货人不能为空', 1);
            return false;
        }
        if (this.state.parameter.Linktel === '' || !regex.test(this.state.parameter.Linktel)) {
            Toast.info('电话号码输入错误，请重新输入！', 1);
            return false;
        }
        if (this.state.parameter.Provinceid === '') {
            Toast.info('请选择省市区', 1);
            return false;
        }
        if (this.state.parameter.Adress === '') {
            Toast.info('请输入正确的详细地址!', 1);
            return false;
        }
        return true;
    }
    render() {
        const { antdDistrict, parameter, defaultAdd ,pickerValue} = this.state;
        return <div className="addaddress">
            <List renderHeader={() => this.state.fname}>
                <InputItem
                    clear name="Consingee"
                    placeholder="请输入收货人姓名" onChange={this.handleChange1} value={parameter.Consingee}
                    ref={el => this.inputRef = el}
                >收货人</InputItem>

                <InputItem
                    clear name="Linktel"
                    placeholder="请输入手机号码" onChange={this.handleChange2} value={parameter.Linktel}
                    ref={el2 => this.inputRef = el2}

                >手机号码</InputItem>

                {
                    this.state.antdDistrict === null ? '' :
                        <Picker
                            title="选择地区"
                            extra={defaultAdd}
                            data={antdDistrict}
                            value={pickerValue}
                            onChange={v => { this.onChange(v) }}  
                      >
                            <CustomChildren>地址</CustomChildren>
                        </Picker>
                }
                <InputItem
                    placeholder="请填写正确的详细地址"
                    name="Adress" onChange={this.handleChange3} value={parameter.Adress}
                    ref={el3 => this.inputRef = el3}
                >详细地址</InputItem>

            </List>
            <div className="footBut">
                <Button onClick={this.onClose}  >取消</Button><Button className="ant-btn2" onClick={this.address} >确定</Button>
            </div>
        </div>

    }
}
